import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Snackbar } from '@mui/material';

const AlertSnackbar = ({ isOpen, onClose, message, success, notification, autoHideDuration = 3000 }) => (
  <Snackbar
    open={isOpen}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    autoHideDuration={autoHideDuration}
  >
    <Alert severity={success ? 'success' : 'error'} variant="filled" className={notification ? 'whiteNotification' : ''} onClose={onClose}>
      {message}
    </Alert>
  </Snackbar>
);

AlertSnackbar.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  success: PropTypes.bool,
  message: PropTypes.string,
  notification: PropTypes.bool,
  autoHideDuration: PropTypes.number
};

export default AlertSnackbar;
